// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3niSw","footer":"ChangeClinic_footer__2lNne"};